// @ts-nocheck
/** @deprecated Use "Accordion" instead. */

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import { TextFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Accordion from "@insite/mobius/Accordion";
import AccordionSection, { AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import useIsomorphicLayoutEffect from "@toolkit/Framework/Common/Hooks/useIsomorphicLayoutEffect";
import React, { FC, useState } from "react";

interface RowModel {
    fields: {
        linkTitle: string;
        isOpen: boolean;
    };
}

const enum fields {
    rows = "rows",
    isOpenByDefault = "isOpenByDefault",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.rows]: RowModel[];
        [fields.isOpenByDefault]: boolean;
    };
}

type Props = OwnProps;

export interface CommonAccordionStyles {
    accordionWrapper?: InjectableCss;
    accordionSection?: AccordionSectionPresentationProps;
}

export const commonAccordionStyles: CommonAccordionStyles = {};

const styles = commonAccordionStyles;

export const commonAccordionWrapperId = "commonAccordionWrapperId";

const CommonAccordion: FC<Props> = ({ id, fields: { rows, isOpenByDefault } }) => {
    const [accordionRows, setAccordionRows] = useState<RowModel[]>([]);

    useIsomorphicLayoutEffect(() => {
        const newRows: RowModel[] = rows.map(row => ({
            fields: {
                ...row.fields,
                isOpen: isOpenByDefault,
            },
        }));

        setAccordionRows(newRows);
    }, [rows]);

    const onToggleHandler = (expanded: boolean, linkTitle: string) => {
        const newRows: RowModel[] = accordionRows.map(row => {
            if (row.fields.linkTitle === linkTitle) {
                return {
                    fields: {
                        ...row.fields,
                        isOpen: !expanded,
                    },
                };
            }

            return row;
        });

        setAccordionRows(newRows);
    };

    if (!accordionRows) {
        return null;
    }

    return (
        <>
            <StyledWrapper id={commonAccordionWrapperId} {...styles.accordionWrapper}>
                <Accordion headingLevel={2}>
                    {accordionRows?.map((accordionRow: RowModel, index) => {
                        const rowId = `${accordionRow.fields.linkTitle}-${index}`;
                        return (
                            <AccordionSection
                                key={rowId}
                                title={accordionRow.fields.linkTitle}
                                headerProps={{ id: accordionRow.fields.linkTitle, headingLevel: 2 }}
                                uid={accordionRow.fields.linkTitle}
                                onTogglePanel={expanded => onToggleHandler(expanded, accordionRow.fields.linkTitle)}
                                expanded={accordionRow.fields.isOpen}
                                {...styles.accordionSection}
                            >
                                <Zone contentId={id} zoneName={`Row-${rowId}`} />
                            </AccordionSection>
                        );
                    })}
                </Accordion>
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: CommonAccordion,
    definition: {
        group: "Common",
        displayName: "Accordion",
        allowedContexts: [], // This widget is deprecated, use "Accordion" instead.
        fieldDefinitions: [
            {
                name: fields.rows,
                editorTemplate: "ListField",
                getDisplay: ({ fields: { linkTitle } }) => linkTitle,
                defaultValue: [],
                fieldType: "Translatable",
                fieldDefinitions: [
                    {
                        name: "linkTitle",
                        displayName: "Row Title",
                        editorTemplate: "TextField",
                        fieldType: "Translatable",
                        defaultValue: "",
                        isRequired: true,
                    } as TextFieldDefinition,
                ],
            },
            {
                name: fields.isOpenByDefault,
                displayName: "Open all accordions sections by default",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
